import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DirectorMasterService {

  constructor(private http: HttpClient,private httpService: HttpService) { }
  addDirector(newDirector) {
    var request = {
            URL: "directorMaster/addDirector",
            DATA: newDirector
    }
    return this.httpService.post(request);

    // var headers = new Headers();
    // headers.append('Content-Type', 'application/json');
    // return this.http.post(environment.pssUrl + 'directorMaster/addDirector', JSON.stringify(newDirector), { headers: headers })
    //         .map(res => res.json());
}

getMasterDirector(dateModel) {
    var request = {
            URL: "directorMaster/filterDirectorMasterByDate/522b2649b2e70464f113c04d",
            DATA: dateModel
    }
    return this.httpService.post(request);
    // return this.http.get(environment.pssUrl + 'directorMaster/522b2649b2e70464f113c04d', )
    //         .map(res => res.json());
}

getDirectorMember() {

    var request = {
            URL: "directorMaster/Members/522b2649b2e70464f113c04d"
    }
    return this.httpService.get(request);

    // return this.http.get(environment.pssUrl + 'directorMaster/Members/522b2649b2e70464f113c04d', )
    //         .map(res => res.json());
}

getRegisterDirector() {
    var request = {
            URL: "directorMaster/getRegisterDirector/522b2649b2e70464f113c04d"
    }
    return this.httpService.get(request);
    // return this.http.get(environment.pssUrl + 'directorMaster/getRegisterDirector/522b2649b2e70464f113c04d', )
    //         .map(res => res.json());
}
getDirectorDetails(directorId: string) {
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.append("x-access-token", token)
    return this.http.get(environment.pssServerUrl + 'directorMaster/getDirectorDetails/' + directorId, { headers: headers })
            .map(res => res);
}

getDirectorById(directorId: string) {
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.append("x-access-token", token)
    return this.http.get(environment.pssServerUrl + 'directorMaster/getDirectorDetails/' + directorId, { headers: headers })
            .map((res: Response) => res.json());
}

updateDirectorDetails(updateDirector) {

    var request = {
            URL: "directorMaster/addDirector",
            DATA: updateDirector
    }
    return this.httpService.post(request);
    // var headers = new Headers();
    // headers.append('Content-Type', 'application/json');
    //   return this.http.put(environment.pssUrl + 'directorMaster/editDirector', updateDirector)
    //       .map(res => res.json());
}

removeDirectorship(directorshipId: string) {
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.append("x-access-token", token)
    return this.http.post(environment.pssServerUrl + 'directorMaster/removeDirectorship/' + directorshipId, null, { headers: headers })
    .map((res: Response) => res.json()) 
}

removeSubDirector(subDirectorId: string) {
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.append("x-access-token", token)
    return this.http.post(environment.pssServerUrl + 'directorMaster/removeSubDirector/' + subDirectorId, null, { headers: headers })
    .map((res: Response) => res.json()) 
}

addRelatives(newRelative) {
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.append("x-access-token", token)
    return this.http.post(environment.pssServerUrl + 'directorMaster/addRelatives', JSON.stringify(newRelative), { headers: headers })
    .map((res: Response) => res.json()) 
}

getRelativesDetails(directorPAN: string) {
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.append("x-access-token", token)
    return this.http.get(environment.pssServerUrl + 'directorMaster/getRelatives/' + directorPAN, { headers: headers })
            .map((res: Response) => res.json());
}

updateRelativeDetails(updateRelative) {
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.append("x-access-token", token)
    return this.http.post(environment.pssServerUrl + 'directorMaster/updateRelatives', updateRelative, { headers: headers })
    .map((res: Response) => res.json()) 
}

removeRelative(relativeId: string) {
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.append("x-access-token", token)
    return this.http.post(environment.pssServerUrl + 'directorMaster/removeRelatives/' + relativeId, null, { headers: headers })
    .map((res: Response) => res.json()) 
}

getUnauthorizeDirectorshipSubDirector(directorId: String) {
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.append("x-access-token", token)
    return this.http.get(environment.pssServerUrl + 'directorMaster/Unauthorized/' + directorId, { headers: headers })
            .map((res: Response) => res.json());
}

getUnRectifiedDirectorshipSubDirector(directorId: String) {
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.append("x-access-token", token)
    return this.http.get(environment.pssServerUrl + 'directorMaster/UnRectified/' + directorId, { headers: headers })
            .map((res: Response) => res.json());
}

authorize(authorizeDirSubdir) {
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.append("x-access-token", token)
    return this.http.post(environment.pssServerUrl + 'directorMaster/getAuthorize', authorizeDirSubdir, { headers: headers })
    .map((res: Response) => res.json()) 
}

rectify(rectifyDirSubdir) {
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.append("x-access-token", token)
    return this.http.post(environment.pssServerUrl + 'directorMaster/getRectify', rectifyDirSubdir, { headers: headers })
    .map((res: Response) => res.json()) 
}

getCompanyDetails(companyId: string) {
    var request = {
            URL: "companyMaster/getById/",
            DATA: companyId
    }
    return this.httpService.getByID(request);
}

getNations() {

    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.append("x-access-token", token)
    return this.http.get(environment.pssServerUrl + 'nationality/', { headers: headers })
            .map(res => res);
}

getCompanyType() {

    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.append("x-access-token", token)
    return this.http.get(environment.pssServerUrl + 'disclosureOfIntrest/companyType/', { headers: headers })
            .map(res => res);
}

getNatureOfInterest() {

    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.append("x-access-token", token)
    return this.http.get(environment.pssServerUrl + 'disclosureOfIntrest/natureOfInterest/', { headers: headers })
            .map(res => res);
}

getDirectorship(dateModel): Promise<any> {

    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.append("x-access-token", token)

    var request = {
            URL: "directorship/filterdirectorshipbydate",
            DATA: dateModel
    }
    return this.http.post(environment.pssServerUrl + request.URL, request.DATA, { headers: headers }).toPromise()
            .then(response => {
                    return Promise.resolve(response => response.json());
            })
}

getSubDirector(dateModel): Promise<any> {

    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.append("x-access-token", token)

    var request = {
            URL: "subdirector/filtersubdirectorbydate",
            DATA: dateModel
    }
    return this.http.post(environment.pssServerUrl + request.URL, request.DATA, { headers: headers }).toPromise()
            .then(response => {
                    return Promise.resolve(response => response.json());
            })
}

getDirectorshipByDate(dateModel) {
    var request = {
            URL: "directorship/filterdirectorshipbydate",
            DATA: dateModel
    }
    return this.httpService.post(request);
}

getSubdirectorByDate(dateModel) {
    var request = {
            URL: "subdirector/filtersubdirectorbydate",
            DATA: dateModel
    }
    return this.httpService.post(request);
}

getRelativesByDate(dateModel) {
    var request = {
            URL: "relatives/filterrelativebydate",
            DATA: dateModel
    }
    return this.httpService.post(request);
}

getRelative(dateModel): Promise<any> {

    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.append("x-access-token", token)

    var request = {
            URL: "relatives/filterrelativebydate",
            DATA: dateModel
    }
    return this.http.post(environment.pssServerUrl + request.URL, request.DATA, { headers: headers }).toPromise()
            .then(response => {
                    return Promise.resolve(response => response.json());
            })
}


addThisDirectorAsKMP(data) {
    var request = {
            URL: "register/addThisDirectorAsKMP",
            DATA: data
    }
    return this.httpService.post(request);
    // return this.http.post(environment.pssUrl + request.URL, request.DATA).toPromise()
    //         .then(response => {
    //                 return Promise.resolve(response.json());
    //         })
}
generateDirectorDocument(object) {
    var request = {
            URL: "director/generateDirectorDocument",
            DATA: object
    }
    return this.httpService.post(request);
}

downloadDirectorFile(id) {
    var token = localStorage.getItem('token')
    window.location.href = environment.pssServerUrl + "director/downloadDocument/" + id + "/" + token;
}

downloadDirectorPdfFile(id) {
    var token = localStorage.getItem('token')
    window.location.href = environment.pssServerUrl + "director/downloadPdfDocument/" + id + "/" + token;
}

generateMbp4bDocument(object) {
    var request = {
            URL: "director/generateMbp4bDocument",
            DATA:object
    }
    return this.httpService.post(request);
}

downloadMbp4bFile(id) {
    var token = localStorage.getItem('token')
    window.location.href = environment.pssServerUrl + "director/downloadMbp4bDocument/" + id + "/" + token;
}

downloadMbp4bPdfFile(id) {
    var token = localStorage.getItem('token')
    window.location.href = environment.pssServerUrl + "director/downloadMbp4bPdfDocument/" + id + "/" + token;
}

getMbp4bData(searchParam) {
    var request = {
            URL: "director/getMbp4bData",
            DATA: searchParam
    }
    return this.httpService.post(request);
}



// exportRegisterOfDirectorsToPdf 
exportRegisterOfDirectorsToPdf(directorId: String) {
    var headers = new Headers();
    headers.append('Content-Type', 'application/pdf');
    return this.http.get(environment.pssServerUrl + 'directorMaster/exportRegisterOfDirectorToPDF/' + directorId)
            .map((res: Response) => res.json());
}
}

